import { getShareInfo, getPlanCmsDetail } from './service';

export default {
  namespace: 'share',
  state: {
    shareInfo: {},
    planCmsDetailInfo: {},
  },
  reducers: {
    setData(state: ShareState, { payload }: PayloadType) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: {
    *getShareInfo({ payload }: PayloadType, { put, call, take }: any): any {
      const res = yield call(getShareInfo, payload);
      yield put({
        type: 'setData',
        payload: {
          shareInfo: { ...res },
        },
      });
      yield put({
        type: 'getPlanCmsDetail',
        payload: {
          productType: payload?.productType,
          productId: res?.product_key,
          planId: res?.plan_key,
        },
      });
    },
    *getPlanCmsDetail({ payload }: PayloadType, { put, call }: any): any {
      const res = yield call(getPlanCmsDetail, payload);
      yield put({
        type: 'setData',
        payload: {
          planCmsDetailInfo: { ...res },
        },
      });
    },
  },
};
